if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
  var viewportmeta = document.querySelectorAll('meta[name="viewport"]')[0];
  if (viewportmeta) {
    viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
    document.body.addEventListener('gesturestart', function() {
      viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
    }, false);
  }
}

var showLocation = document.getElementById("summary");

jQuery(function($){
  /*$('iframe').each(function(){
    //function injectCSS(){
      $(this).contents().find('head').append(
        $('<link/>', { rel: 'stylesheet', href: 'styles.min.css', type: 'text/css' })
      );
      alert('!');
    //}

    //var iframe = $(this);
    //iframe.on('load', injectCSS);
    //injectCSS();
  });*/
  
  /*$('#ny .store-locate .list-group .item').each(function(){
    if ($(this).find('.todays-hours').hasClass('.opennow')){
      $(this).addClass('store-open');
      alert('Open');
    } else if ($(this).find('.todays-hours').hasClass('.closenow')) {
      $(this).addClass('store-close')
      //alert('Close');
    };
  });*/

  $('.item.store-close').hide();

  $('#hours-filter').find('input:checkbox').live('click', function () {
    $('.item.store-close').show();
    $('#ny .store-locate .panel-group .panel').each(function(){
      var count = $(this).find('.list-group .item').length;
      $(this).find('a .count').html('('+count+')');
    });
  
    var countSum = $('#ny .list-group .item').length;
    $('#summary .count-sum').html(countSum);
    
    $('#hours-filter').find('input:checked').each(function () {
      //$('.item.store-open').show();
      $('.item.store-close').hide();
      $('#ny .store-locate .panel-group .panel').each(function(){
        var count = $(this).find('.list-group .item.store-open').length;
        $(this).find('a .count').html('('+count+')');
        if ($(this).find('a .count').html() == '0'){
          $(this).hide();
        }
      });
    
      var countSum = $('#ny .list-group .item.store-open').length;
      $('#summary .count-sum').html(countSum);
      if (countSum == 0){
        $('.store-locate').append('<h4 class="no-locations">There are no open stores near you at this time.</h4>');
      }
    });
  });

  $('#ny .store-locate .panel-group .panel').each(function(){
    var count = $(this).find('.list-group .item.store-open').length;
    $(this).find('a .count').html('('+count+')');
  });

  var countSum = $('#ny .list-group .item.store-open').length;
  $('#summary .count-sum').html(countSum);

  $('.service-hero-top').css({'background-image':'url('+$('.service-hero-top img').attr('src')+')'});
  $('.service-hero-top > img').remove();
  $('#services-content .service-top .bg-image').css({'background-image':'url('+$('#services-content .service-top .bg-image img').attr('src')+')'});
  $('#services-content .service-top .bg-image img').remove();
  $('.ser-img').each(function(){
    $(this).css({'background-image':'url('+$(this).find('.ser-feat-img').attr('src')+')'});
    $(this).find('.ser-feat-img').remove();
  });
  /*$('.link-out').append('<i class="fas fa-external-link-alt"></i>');*/
  $('#ny .store-locate a').addClass('collapsed');
  $('.single-location .btn-link').addClass('collapsed');
  if ($(window).width() < 768) {
    $('#menu-main-navigation').css({'max-height':$(window).height()-$('header').height() + 'px','margin-top':'5px'});
    if ($('.services_nav .dropdown .dropdown-menu .current_page_item')){
      var childNav = $('.parent-pageid-1605 .pom-breadcrumbs [rel="v:child"] a');
      $('.parent-pageid-1605 .pom-breadcrumbs span[rel="v:child"]').text('');
      $(childNav).appendTo('.parent-pageid-1605 .pom-breadcrumbs span[rel="v:child"]');
    }
    $('.footer-apps').clone().appendTo('#menu-main-navigation');
    $('.social-links').clone().appendTo('#menu-main-navigation');
    $('#ny .item .store-excerpt').each(function(){
      $(this).find('.pom-name').append($(this).find('.hours-label'));
      //$(this).prepend($(this).find('.pom-name'));
    });
    $('.single-location .btn-orange').appendTo('.single-location .address .col-xs-3.link-out').html('');
    $('.single-location .link-out img').appendTo('.single-location .link-out .btn-orange');
    $('.single-location .link-out p').appendTo('.single-location .link-out .btn-orange');
    $('.location-sidebar ul').appendTo('.single-location .hours-list .col-xs-12');
    var hLabel = $('.dropdown-blue .hours-label').html();
    $('.dropdown-blue .hours-label').appendTo('.loc-hours-mob .status-m').html(hLabel);
    //$('.loc-hours-mob .hours-m').appendTo('.loc-hours-mob');
    $('.dropdown-blue .dropdown-toggle span:first-child').appendTo('.loc-hours-mob .hours-m');


    var ww = $(window).width();
    //var mw = $('#menu-main-navigation>ul>li').width();
    $('#menu-main-navigation .menu-item-has-children').each(function(){
      $(this).find('.nav').css({'width':ww *0.88 + 'px'});
    });
    $('.navbar-toggle').on('click',function(){
      if($('.toggleMenu').hasClass('active')){
        $('.nav-second-bg').addClass('hide');
      } else {
        $('.nav-second-bg').removeClass('hide');
      }
    });
    $('.nav .menu-item-has-children span.caret').append('<i class="fa fa-chevron-down"></i>');
    $('.home-find-store').prepend('<div class="m-find-overlay"></div>');
    $('.services_nav').insertBefore('.service-hero-top');
    $('#services .service-row').each(function(){
      $(this).find('.ser-img').css({'min-height':$(this).find('.ser-txt').height()+60+'px'});
    });
    $('.service-top .bg-image').css({'height':$('.service-top .ser-txt').height()+40+'px'});
    $('.page-id-1008 .pom-banner .integer_base.inner_pae_sec_tion').appendTo('.page-id-1008 .service-hero');
    $('.page-id-1008 .service-hero .integer_base.inner_pae_sec_tion .ser-txt').addClass('m-color-tr');
    $('ul.icons-list li').each(function(){
      $(this).addClass('col-xs-6 icons-list-item');
    });
    //if ($('body.page-blog') || $('body.page-resources')){
      var fItem = $('.articles-list .posts-loop .filter li');
      var fArray = [];
      fItem.each(function() {
        var position = $( this ).position();
        if (position.left < 25){
          $(this).css({'margin-left':'0'});
          $(this).addClass('flex-first');
        }
        fArray.push({
          'name': $(this).text(),
          'left': position.left
        });
      });
    //};
    $('.page-contact-us .contact-frame.phone-frame').insertAfter('.content-main > .txt-hero');
    $('.page-contact-us .content-right .contact-frame').insertAfter('.page-contact-us .contact-frame.phone-frame');
    /*$('.page-contact-us .content-right .contact-frame').each(function(){
      $(this).insertBefore('.page-contact-us .content-main .contact-frame');
    });*/
  } else {
    //$('.reviews').appendTo('.location-sidebar');
    $('#services .service-row').each(function(){
      $(this).find('.ser-img').css({'min-height':$(this).find('.ser-txt').height()+216+'px'});
    });
    $('.vertical-align').each(function(){
      $(this).find('.bg-image').height($(this).find('.ser-txt').height()+parseInt($(this).find('.ser-txt').css("padding-top"))+parseInt($(this).find('.ser-txt').css("padding-bottom")));
    });
    $('.vertical-align.no-img').each(function(){
      var maxH = 0;
      if ($(this).find('div.ser-txt:first-child') > $(this).find('div.ser-txt:nth-child(2)')){
        maxH = $(this).find('div.ser-txt:first-child').height()/*+parseInt($(this).find('div:first-child').css("padding-top"))+parseInt($(this).find('div:first-child').css("padding-bottom"))*/;
      } else {
        maxH = $(this).find('div.ser-txt:nth-child(2)').height()/*+parseInt($(this).find('div:nth-child(2)').css("padding-top"))+parseInt($(this).find('div:nth-child(2)').css("padding-bottom"))*/;
      }
      $(this).find('div.ser-txt').height(maxH);
    });
    $('ul.icons-list li').each(function(){
      $(this).addClass('col-xs-3 icons-list-item');
    });
  };
  $('#services .service-row:even').addClass('bg-left');
  $('#services .service-row:odd').addClass('bg-right');
  $('#services .service-row.bg-right').each(function(){
    $(this).append($(this).find('.ser-img'));
  });
  $('.ser-steps > ol > li').each(function(){
    var a = parseInt($(this).index())+1;
    //alert(a);
    $(this).addClass('step-' + a);
    $(this).prepend('<span class="step-num step-num-' + a + '">' + a + '</span>');
  });
  $('.services-content .bg-image').each(function(){
    $(this).css({'background-image':'url('+$(this).find('img').attr('src')+')'});
    $(this).find('img').remove();
  });
  $('.ser-steps .send-form').appendTo($('.ser-steps .step-2'));
  /*$('.inner_2_page_s').each(function(){

  });*/

  $('.reviews-link a').on('click', function(){
    $('#customer-reviews .collapse').addClass('in');
    $('#customer-reviews a.btn-link').removeClass('collapsed');
  });
});

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});

/*function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
  {
    //return 'iOS';
    jQuery('<a href="#!!!"><img src="/wp-content/uploads/2018/06/get_on_google_play.png" alt="" /></a>').appendTo(jQuery('.footer-apps .container'));
  }
  else if( userAgent.match( /Android/i ) )
  {
    //return 'Android';
    jQuery('<a href="#"><img src="/wp-content/uploads/2018/06/get_on_google_play.png" alt="" /></a>').appendTo(jQuery('.footer-apps .container'));
  }
  else
  {
    //return 'unknown';
    jQuery('<a href="#"><img src="/wp-content/uploads/2018/06/get_on_google_play.png" alt="" /></a>').appendTo(jQuery('.footer-apps .container'));
  }
}*/